<template>
    <div class="table-cell-lambda-log-duration">{{ duration }}</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { LambdaLog } from '@models';

/**
 * `TableCellLambdaLogDuration` component properties.
 */
export interface Props {
  item: LambdaLog;
}

const props = defineProps<Props>();

const duration = computed(() => `${props.item.duration / 1000}s / ${props.item.timeout / 1000}s`);

</script>

<script lang="ts">
declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellLambdaLogDuration: ComponentWithProps<Props>;
  }
}

export default { name: 'TableCellLambdaLogDuration' };
</script>

<style scoped lang="scss">
</style>